const playerBuildUrl = 'https://steadycdn.com/podigee_podcast_player/2024-05-22-6a3d288';
export const playerUrl = `${playerBuildUrl}/javascripts/podigee-podcast-player.js`;
export const options = {
    theme: {
        html: playerBuildUrl + '/themes/steady/index.html',
        css: playerBuildUrl + '/themes/steady/index.css'
    }
};
